import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Appfooter from '../components/Appfooter';
import LeftMenu from '../components/LeftMenu';
import { Spinner } from 'react-bootstrap';
import { getSubscribers } from '../services/creator';
import SubscriptionStatus from '../enums/SubscriptionStatus';

const Subscribers = () => {
  const [subscribers, setSubscribers] = useState<Subscribers[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSubscribers = async () => {
      try {
        const subscribers = await getSubscribers();

        const filteredSubscribers = subscribers.filter(
          (subscriber) =>
            subscriber.status !== SubscriptionStatus.NEW &&
            subscriber.status !== SubscriptionStatus.CANCELLED
        );

        setSubscribers(filteredSubscribers);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    loadSubscribers();
  }, []);

  return (
    <>
      <Header />
      <LeftMenu />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                {loading ? (
                  <div
                    className="align-self-center d-flex flex-column justify-content-center align-items-center"
                    style={{
                      padding: 100,
                    }}
                  >
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-warning"
                    />
                  </div>
                ) : (
                  <>
                    <div className="card-body p-lg-5 w-100 border-0 mb-5">
                      <h4 className="font-xs text-black fw-600 mb-0 mt-2">
                        {`Assinantes (${subscribers.length})`}
                      </h4>
                      <div className="mb-5 d-flex flex-wrap justify-content-center mt-5">
                        {subscribers.length ? (
                          subscribers.map((value, index) => (
                            <div
                              className="p-2"
                              style={{
                                width: 150,
                                height: 150,
                              }}
                            >
                              <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                                <div className="card-body d-block w-100 ps-3 pe-3 pb-4 text-center">
                                  <figure 
                                    className="overflow-hidden avatar ms-auto me-auto mb-0 position-relative z-index-1"
                                    style={{ width: '65px', height: '65px' }}
                                  >
                                    <img
                                      src={
                                        value.metadata.profile.avatar ??
                                        'assets/images/user-100x100.png'
                                      }
                                      alt="avater"
                                      className="float-right p-0 bg-white rounded-circle w-100 h-100 shadow-xss"
                                      style={{ objectFit: 'cover' }}
                                    />
                                  </figure>
                                  <div className="clearfix w-100"></div>
                                  <h4 className="fw-700 font-xsss mt-3 mb-0">
                                    {value.metadata.username}{' '}
                                  </h4>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="align-self-center d-flex flex-column justify-content-center align-items-center p-5">
                            <img
                              src="assets/images/logo-blank.png"
                              alt="avater"
                              style={{
                                width: 50,
                                height: 50,
                                objectFit: 'contain'
                              }}
                            />
                            <span className="text-grey-500 m-2 font-xss text-center">
                              Nenhum assinante no momento
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </>
  );
};

export default Subscribers;
